import { queryOptions } from '@tanstack/react-query'
import { expenseApi } from './api'
import { ExpenseFilter } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const expenseQueries = {
  all: () => ['expenses'],
  retrieve: (id: string) => {
    return queryOptions({
      queryKey: [...expenseQueries.all(), id],
      queryFn: () => expenseApi.retrieve(id),
      enabled: Boolean(id),
    })
  },
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<ExpenseFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) => {
    // Extract includeReimbursableOptions flag and reimbursable filters
    const { includeReimbursableOptions, isReimbursable, isReimbursed, ...restFilters } =
      filters || {}

    // Build API filters - only include reimbursable options if flag is true
    const apiFilters: Partial<ExpenseFilter> = {
      ...restFilters,
      ...(includeReimbursableOptions && {
        isReimbursable,
        ...(isReimbursable && { isReimbursed }),
      }),
    }

    return queryOptions({
      queryKey: [...expenseQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await expenseApi.list({
          filters: apiFilters,
          pagination,
        })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    })
  },
  listCategories: (country?: string | null) => {
    return queryOptions({
      queryKey: [...expenseQueries.all(), 'categories', { country: country ?? undefined }],
      queryFn: () => expenseApi.csc.listCategoryOpts({ country: country ?? undefined }),
      enabled: true,
    })
  },
  listCashFlowTypeOpts: () => {
    return queryOptions({
      queryKey: [...expenseQueries.all(), 'cash-flow-type'],
      queryFn: () => expenseApi.csc.listCashFlowTypeOpts(),
      enabled: true,
    })
  },
  listTransactionTypeOpts: () => {
    return queryOptions({
      queryKey: [...expenseQueries.all(), 'transactionTypeOpts'],
      queryFn: () => expenseApi.csc.listTransactionTypeOpts(),
      enabled: true,
    })
  },
}
